import React from "react";
import { Link } from "react-router-dom";

import Ripples from "react-ripples";

import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";

import cookie from 'react-cookie';

import NfcIcon from "@material-ui/icons/Nfc";
import IconButton from "@material-ui/core/IconButton";


const MenuItem = ({ active, children, to }) => (
	<Link to={to} className="bottomNav-item">
		{children}
	</Link>
);

function getOS() {
	var userAgent = window.navigator.userAgent,
		platform = window.navigator.platform,
		macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
		windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
		iosPlatforms = ['iPhone', 'iPad', 'iPod'],
		os = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'Mac OS';
        if(userAgent.indexOf("iPad;")>-1) os = 'iPad';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	return os;
}


const Header = () => {

	let struserid = cookie.load("general_userid");
	var struserdbid = cookie.load("general_userdbid");

	if (typeof (struserdbid) === 'undefined')
		struserdbid = '0';

	var library_url="/library_audiobook";

	var {Platform} = React;

	let strnfc = "";

	let os = getOS();
	//alert(os);

	if (os === 'iOS') {
	    strnfc =
            <Ripples>
            <IconButton href={`mcbab://nfc/${struserdbid}&0`}><NfcIcon style={{fontSize:20, marginLeft:'10px'}} /></IconButton></Ripples>
            }


	if (struserid !== null && struserid.length > 0) {
		return (
			<React.Fragment> 
                <br/><p/>
                <br/><p/>
                <br/><p/>
				<div className="bottomNav">
					<Ripples>
						<MenuItem to={"/HomeAudioBook"}>
							<HomeOutlinedIcon />
						</MenuItem>
					</Ripples>
					<Ripples>
						<MenuItem to={{
							pathname: "/cateview_audiobook",
							state: {
							cursel: 0
						    }
						    }}>
							<LibraryBooksOutlinedIcon />
						</MenuItem>
					</Ripples>
					<Ripples>
						<MenuItem to={"/search_audiobook"}>
							<SearchOutlinedIcon />
						</MenuItem>
					</Ripples>
					<Ripples>
						<MenuItem to={library_url}>
							<PersonOutlineOutlinedIcon />
						</MenuItem>
					</Ripples>
					{strnfc}
				</div>
			</React.Fragment>
		);
            }

	return (
		<React.Fragment>
                <br/><p/>
                <br/><p/>
                <br/><p/>
			<div className="bottomNav">
				<Ripples>
					<MenuItem to={"/"}>
						<HomeOutlinedIcon />
					</MenuItem>
				</Ripples>
				<Ripples>
					<MenuItem to={{
						pathname: "/cateview_audiobook",
						state: {
						cursel: 0
					    }
					    }}>
						<LibraryBooksOutlinedIcon />
					</MenuItem>
				</Ripples>
				<Ripples>
					<MenuItem to={"/search_audiobook"}>
						<SearchOutlinedIcon />
					</MenuItem>
				</Ripples>
				{strnfc}
			</div>
		</React.Fragment>
	)
            };

export default Header;
